import React, { useCallback, useMemo, useState } from "react";
import { useLiquitySelector } from "@liquity/lib-react";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquity } from "../hooks/LiquityContext";
import { useTransactionFunction } from "../components/Transaction";
import { Decimal } from "@liquity/lib-base"
import { Button } from "../components/PSY/Button"
import Select from 'react-select'
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers"
import { CollateralLexicons } from "src/lexicon"
import { CollateralOption } from "../components/PSY/CollateralOption";

const options = CollateralLexicons.map(({ key, term, iconUrl }) => ({ value: key, label: `Mock ${term}`, iconUrl }))

export const Faucet: React.FC = () => {
  const [collateral, setCollateral] = useState(options[0]);

  const select = useCallback(({ collateralStates }: LiquityStoreState) => {
    const { isMinted } = collateralStates[collateral.value]
    return { isMinted }
  }, [collateral])

  const { liquity } = useLiquity();
  const { isMinted } = useLiquitySelector(select);
  const { userAddress } = liquity.connection
  const disabled = !userAddress ? true : isMinted

  const { assetAddress } = useMemo(() => {
    return getContractAddressByCollateralKey(liquity.connection, collateral.value)
  }, [liquity.connection, collateral.value])

  // TODO: mint each collateral
  const [sendTransaction] = useTransactionFunction('mint', liquity.send._mintAsset.bind(liquity.send, Decimal.from(10), assetAddress, undefined));

  return (
    <div className="flex flex-col justify-start items-center w-full">
      <Select
        options={options}
        defaultValue={collateral}
        formatOptionLabel={(option) => (
          <CollateralOption {...option} />
        )}
        onChange={(option) => {
          const val = Object.assign({}, option)
          setCollateral(val)
        }}
        className="react-select-container mt-8 w-80"
        classNamePrefix="react-select"
      />
      <div className="flex flex-col items-center w-full">
        <div className="text-style-desc mt-40">
          PSY Testnet faucet is available.<br/>

          {!userAddress ? (
            <>
              Please connect your wallet to receive 10 mock token.
            </>
          ) : (
            <>
              {!isMinted ? (
                <>
                  You can receive 10 mock token.
                </>
              ) : (
                <>
                  You already have received 10 mock token.
                </>
              )}
            </>
          )}

        </div>
        <div className="w-1/4 flex flex-row mt-8">
          <Button onSubmit={sendTransaction} disabled={disabled} className="flex flex-1">Mint</Button>
        </div>
      </div>
    </div>
  )
}